import React from 'react';
import Button from '@mui/material/Button';
import ManualModal from '../../makeupScheduler/manualModal';
// import AreYouSureModal from '../../../components/AreYouSureModal';

const ManualMakeupButtonModal = ({
    course,
    colors, 
    handlePopOverClose,
    enqueueSnackbar,
    socketConnected,
    socket,
}) => {

    // const [areYouSureModalOpen, setAreYouSureModalOpen] = React.useState(false);
    
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => { setOpen(false); handlePopOverClose(); };

    return (
        <>
            <Button 
                onClick={handleOpen} 
                sx={{ 
                    p: 1, 
                    width: "100%",
                    bgcolor: colors.redAccent[900],
                    borderRadius: "0px",
                    '&:hover': {
                        bgcolor: colors.redAccent[800],
                    },
                }}
            >
                Manual Makeup
            </Button>
            <ManualModal open={open} onClose={handleClose} _course={course} fromWeekly={true} />
        </>
    )
}

export default ManualMakeupButtonModal